export default __webpack_public_path__ + "static/media/facility_04_1.927b8078.png";